import styled from "styled-components";
import Img from "../../../../../../commons/Img";

export const Wrapper = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  font-family: "OpenSansRegular";
  box-sizing: border-box;
`;

export const HelpIcon = styled(Img)`
  height: 16.67px;
  width: 16.67px;
  margin-left: 5px;
  @media (max-width: 1400px) {
    height: 12.5px;
    width: 12.5px;
  }
`;